/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Inject, Injectable} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';
import {AdnResourceListService} from '../common/controller/adn-resource-list.service';
import {lineItemListCommons} from './line-item-commons';
import {AppLocaleService} from '../common/locale/app-locale.service';
import {OrderResource} from '../../components/api/resources/resource/order.resource';
import {TeamResource} from '../../components/api/resources/resource/team.resource';
import {LineItemResource} from '../../components/api/resources/resource/line-item.resource';
import {AdnTimeShifterService} from '../../components/util/adn-time-shifter.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';


export type LineItemListView = 'LINE_ITEM_VIEW' | 'ORDER_VIEW';

export interface LineItemEmbeddedListOptions {
  listId: string;
  moreParams: Record<string, any>;
  view?: LineItemListView;
  advertiserId?: string;
  blockTeams?: boolean;
  onAfterFill?: (list: any) => void;
}

@Injectable({
  providedIn: 'root'
})
export class LineItemListSetupService {
  constructor(
    private readonly listService: AdnResourceListService,
    @Inject(LineItemResource) private readonly LineItem: any,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    @Inject(AdnTimeShifterService) private readonly adnTimeShifter: any,
    private readonly translate: TranslateService,
    private readonly appLocale: AppLocaleService,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any,
    @Inject(TeamResource) private readonly Team: any,
    @Inject(OrderResource) private readonly Order: any
  ) {
  }

  applyListCommons(ctrl: any, afterFill: boolean, view: LineItemListView = 'LINE_ITEM_VIEW'): void {
    if (!afterFill && !ctrl.perms) {
      ctrl.perms = this.LocalUserPermissions.getAllVisPermissions();
    }
    lineItemListCommons(
      ctrl,
      afterFill,
      this.LocalNetworkProfile,
      this.adnTimeShifter,
      this.translate,
      this.appLocale,
      this.LocalUserPermissions,
      this.Team,
      this.Order,
      view
    );
  }

  createEmbeddedList(options: LineItemEmbeddedListOptions): any {
    const list: any = {};
    const view = options.view || 'LINE_ITEM_VIEW';

    this.listService.createBasicList(list, this.LineItem, options.listId, {
      moreParams: options.moreParams,
      baseTable: 'lineItem',
      afterFill: () => {
        this.applyListCommons(list, true, view);
        options.onAfterFill?.(list);
      }
    });

    list.perms = this.LocalUserPermissions.getAllVisPermissions();
    this.applyListCommons(list, false, view);

    if (options.blockTeams) {
      list.blockTeams();
    }
    if (options.advertiserId) {
      list.assignAdvertiser(options.advertiserId);
    }

    return list;
  }
}
